import { inviteSpouse, isFamilyPlanRequiredError, type InviteSpouseParams } from '@healthshare/shared/commands/memberships'
import { useAsyncAction } from "./useAsyncAction"
import { useAppSelector } from "./reduxToolkit"
import { useBackendApi } from "./useBackendApi"

export { isFamilyPlanRequiredError }
export type { InviteSpouseParams } from '@healthshare/shared/commands/memberships'

export type InviteSpouseResult = {
  ok: true
  created: boolean
}

/**
 * Invites a spouse to co-administer the current membership. Posts to the
 * jwt.auth-protected Laravel endpoint via the shared `inviteSpouse` command,
 * which creates the spouse's account (passwordless), grants them admin on the
 * membership, links any existing spouse dependent row, and emails them a
 * sign-in invitation.
 *
 * Returns a useAsyncAction tuple — errors are reported to Sentry automatically.
 */
export function useInviteSpouse() {
  const api = useBackendApi()
  const membershipId = useAppSelector((s) => s.membership.membershipId)

  return useAsyncAction(async (params: InviteSpouseParams): Promise<InviteSpouseResult> => {
    if (!membershipId) {
      throw new Error('useInviteSpouse requires a membershipId')
    }
    return inviteSpouse(api, membershipId, params)
  }, [api, membershipId])
}
